import { useMutation, useQueryClient } from '@tanstack/react-query'

import { axiosInstance } from '@/modules/shared/lib/axios'
import { QUERY_KEY_SETTINGS_ADMIN_PANEL } from '@/lib/api/constants'

type Props = {
  userIds: Array<string | number>
}

/**
 * Usuwanie użytkowników z panelu admina - te same endpointy, których używał stary panel.
 *
 * Panel otwarty w kontekście firmy tylko odpina użytkownika od firmy
 * (`/config-api/user/removeFromCompany`); otwarty globalnie kasuje konto
 * (`/config-api/user/delete`). Osobne od `useMutationAdminUserRemove`, bo tamto woła
 * `/config-api/{companyId}/configuration/admin/users/{id}` i wymaga firmy.
 */
export function useMutationRemoveAdminPanelUsers(companyId?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ userIds }: Props) => {
      await Promise.all(
        userIds.map((id) =>
          companyId
            ? axiosInstance.post('/config-api/user/removeFromCompany', {
                userId: Number(id),
                companyId,
              })
            : axiosInstance.post('/config-api/user/delete', { id: String(id) }),
        ),
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_ADMIN_PANEL, 'users'],
      })
    },
  })
}
